import { IForbiddenErrorConfig } from '../../../../components/Fallback/GenericErrorFallback';

/**
 * Centralized forbidden error message configurations for Company Profile panels.
 * Messages are organized by criticality tier to provide appropriate context and guidance.
 */

/**
 * PRIMARY TIER: Critical data - page is meaningless without this information
 * Shows "Access Restricted" with support contact information
 */
export const PrimaryForbiddenMessage: IForbiddenErrorConfig = {
  title: 'Access Restricted',
  message: "You don't have permission to view detailed information for this company.",
  showContactSupport: true,
};

/**
 * SECONDARY TIER: Useful data - page works without it but provides value
 * Shows informational "Data Not Available" message without alarming language
 */
export const SecondaryForbiddenMessage: IForbiddenErrorConfig = {
  title: 'Data Not Available',
  message: 'This information is not accessible for this company.',
  showContactSupport: false,
};

/**
 * TERTIARY TIER: Optional contextual information
 * Simple "No data available" message with minimal interruption
 */
export const TertiaryForbiddenMessage: IForbiddenErrorConfig = {
  title: '',
  message: 'No data available',
  showContactSupport: false,
};
